import CloseIcon from '@assets/images/common/icon/close.svg';
import { MediaTag } from '@src/api/types/mediaTag';
import { SupportServiceTag } from '@src/api/types/supportServiceTag';
import Modal from '@src/layouts/Modal';
import Button from '@src/ui/elements/button/Button';
import ErrorMessage from '@src/ui/elements/form/ErrorMessage';
import Input from '@src/ui/elements/form/Input';
import Select from '@src/ui/elements/form/Select';
import { firstError } from '@src/utils/errorMessageUtils';

export interface TagFields {
  name?: string;
  enabled?: boolean | number;
}

interface EditCategoryModalProps {
  isOpen: boolean;
  tag: Partial<MediaTag> | Partial<SupportServiceTag> | null;
  onCategoryChange: (updatedTag: Partial<MediaTag> | Partial<SupportServiceTag>) => void;
  errors?: {
    name?: string[];
    enabled?: string[];
  };
  onSave: () => void;
  onCancel: () => void;
}

const CreateEditTagModal: React.FC<EditCategoryModalProps> = ({
  isOpen,
  tag,
  onCategoryChange,
  errors,
  onSave,
  onCancel,
}) => {
  if (!isOpen) {
    return null;
  }

  const title = tag?.id ? 'タグを編集' : 'タグを新規作成';

  const EnabledOptions = [
    { id: '1', name: '有効' },
    { id: '0', name: '無効' },
  ];

  const handleNameChange = (newName: string) => {
    onCategoryChange({
      ...tag,
      name: newName,
      enabled: tag?.enabled !== undefined ? tag?.enabled : undefined,
    });
  };

  const handleEnabledChange = (newEnabled: string) => {
    onCategoryChange({
      ...tag,
      name: tag?.name || '',
      enabled: newEnabled ? Number(newEnabled) : undefined,
    });
  };

  return (
    <Modal width='500px'>
      <div className='flex grow flex-col gap-8 px-8 py-10'>
        <div className='border-b border-b-gray-350 pb-4'>
          <h2 className='text-lg font-semibold'>{title}</h2>
        </div>
        <div className='flex flex-col gap-8'>
          <div className='flex flex-col gap-1'>
            <p>タグ名</p>
            <Input
              value={tag?.name}
              onChange={(e) => handleNameChange(e.target.value)}
            />
            {errors?.name && <ErrorMessage>{firstError(errors.name)}</ErrorMessage>}
          </div>
          <div className='flex flex-col gap-1'>
            <p>ステータス</p>
            <Select
              items={EnabledOptions}
              initialValue={tag?.enabled !== undefined ? tag?.enabled?.toString() : ''}
              onSelect={handleEnabledChange}
            />
            {errors?.enabled && <ErrorMessage>{firstError(errors.enabled)}</ErrorMessage>}
          </div>
        </div>
        <div className='mt-auto flex justify-center gap-5'>
          <div className='w-[172px]'>
            <Button
              variant='secondary'
              fullRounded
              fullWidth
              outline
              onClick={onCancel}
            >
              キャンセル
            </Button>
          </div>
          <div className='w-[172px]'>
            <Button
              fullRounded
              fullWidth
              outline
              onClick={onSave}
            >
              保存する
            </Button>
          </div>
        </div>
        <button
          className='absolute right-[8px] top-[8px] grid size-5 place-items-center rounded-full bg-gray-50'
          onClick={onCancel}
          data-testid='close-icon-button'
        >
          <img
            src={CloseIcon}
            alt=''
            width={16}
            height={16}
          />
        </button>
      </div>
    </Modal>
  );
};

export default CreateEditTagModal;
